"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var styled_components_1 = __importStar(require("styled-components"));
var hooks_1 = require("../../accessibility/hooks");
var hooks_2 = require("../../utils/hooks");
var responsive_1 = require("../../utils/responsive");
var _1 = require(".");
var ARROW_HEIGHT = 9;
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Popover = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var visible = _a.visible, placement = _a.placement, _b = _a.triggerHeight, triggerHeight = _b === void 0 ? 0 : _b;
    var isRightAligned = placement === 'right';
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      display: ", ";\n      padding: ", ";\n      z-index: 1;\n\n      ", ";\n    "], ["\n      display: ", ";\n      padding: ", ";\n      z-index: 1;\n\n      ", ";\n    "])), visible ? 'block' : 'none', isRightAligned ? '0' : "".concat(ARROW_HEIGHT, "px 0"), isRightAligned && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        margin-left: 10px;\n        margin-top: -", "px;\n      "], ["\n        margin-left: 10px;\n        margin-top: -", "px;\n      "])), triggerHeight / 2 + 3));
});
var Arrow = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  width: 18px;\n  height: 9px;\n  font-size: ", "px;\n\n  &[data-placement*='top'] {\n    bottom: 0;\n    left: 0;\n    margin-left: 7px;\n\n    &::before {\n      border-width: 9px 9px 0 9px;\n      border-top-color: ", ";\n    }\n  }\n\n  &[data-placement*='bottom'] {\n    top: 0;\n    left: 0;\n    margin-left: 7px;\n\n    &::before {\n      border-width: 0 9px 9px 9px;\n      border-bottom-color: ", ";\n    }\n  }\n\n  &[data-placement*='right'] {\n    top: 0;\n    left: 0;\n    margin-left: -12px;\n    margin-top: 7px;\n\n    &::before {\n      border-width: 9px 9px 9px 0;\n      border-right-color: ", ";\n    }\n  }\n\n  &::before {\n    content: '';\n    margin: auto;\n    display: block;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-color: transparent;\n  }\n"], ["\n  position: absolute;\n  width: 18px;\n  height: 9px;\n  font-size: ", "px;\n\n  &[data-placement*='top'] {\n    bottom: 0;\n    left: 0;\n    margin-left: 7px;\n\n    &::before {\n      border-width: 9px 9px 0 9px;\n      border-top-color: ", ";\n    }\n  }\n\n  &[data-placement*='bottom'] {\n    top: 0;\n    left: 0;\n    margin-left: 7px;\n\n    &::before {\n      border-width: 0 9px 9px 9px;\n      border-bottom-color: ", ";\n    }\n  }\n\n  &[data-placement*='right'] {\n    top: 0;\n    left: 0;\n    margin-left: -12px;\n    margin-top: 7px;\n\n    &::before {\n      border-width: 9px 9px 9px 0;\n      border-right-color: ", ";\n    }\n  }\n\n  &::before {\n    content: '';\n    margin: auto;\n    display: block;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-color: transparent;\n  }\n"])), ARROW_HEIGHT, function (_a) {
    var theme = _a.theme;
    return theme.colors.background.inverse;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.background.inverse;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.background.inverse;
});
var TooltipLabel = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  max-width: 320px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  background-color: ", ";\n  color: ", ";\n  box-shadow: ", ";\n\n  ", "\n"], ["\n  max-width: 320px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  background-color: ", ";\n  color: ", ";\n  box-shadow: ", ";\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.inverse;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.text.inverse;
}, function (_a) {
    var theme = _a.theme;
    return "0px 6px 16px 8px ".concat(theme.colors.boxShadow);
}, (0, responsive_1.large)((0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border-radius: 12px;\n    padding: 16px 20px;\n  "], ["\n    border-radius: 12px;\n    padding: 16px 20px;\n  "])))));
/**
 * A component that reveals a popout message when a user interacts with or
 * focuses on an element.
 *
 * Tooltip also provides a `useTooltipState` hook which can be used in conjunction with the `open` prop to fully control the tooltip.
 */
var Tooltip = function (_a) {
    var _b;
    var _c = _a.placement, requestedPlacement = _c === void 0 ? 'top' : _c, triggerElement = _a.triggerElement, tooltipContents = _a.tooltipContents, accessibilityId = _a.accessibilityId, overflowBoundaryRef = _a.overflowBoundaryRef, props = __rest(_a, ["placement", "triggerElement", "tooltipContents", "accessibilityId", "overflowBoundaryRef"]);
    var _d = (0, _1.useTooltipState)(), open = _d.open, setOpen = _d.setOpen, handlers = _d.handlers;
    var previousOpenPropValue = (0, hooks_2.usePreviousValue)(props.open);
    var previousOpenStateValue = (0, hooks_2.usePreviousValue)(open);
    var _e = (0, react_1.useState)(false), tooltipInPosition = _e[0], setTooltipInPosition = _e[1];
    var triggerContainerRef = (0, react_1.useRef)(null);
    var triggerElementHeight = (_b = triggerContainerRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight;
    (0, hooks_1.useHandleEscapeKeyPress)(function () {
        setOpen(false);
    });
    return (react_1.default.createElement(react_popper_1.Manager, null,
        react_1.default.createElement("div", { ref: triggerContainerRef },
            react_1.default.createElement(react_popper_1.Reference, null, function (_a) {
                var ref = _a.ref;
                return (react_1.default.createElement(Container, __assign({}, (typeof props.open === 'boolean' ? null : handlers), props, { ref: ref }), react_1.default.cloneElement(triggerElement, {
                    'aria-describedby': accessibilityId,
                    tabIndex: 0,
                    role: 'button',
                })));
            }),
            react_1.default.createElement(react_popper_1.Popper, { placement: requestedPlacement, modifiers: [
                    {
                        name: 'preventOverflow',
                        enabled: true,
                    },
                    {
                        name: 'flip',
                        options: {
                            boundary: overflowBoundaryRef,
                            fallbackPlacements: ['bottom', 'top', 'right'],
                        },
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 2],
                        },
                    },
                ] }, function (_a) {
                var ref = _a.ref, style = _a.style, placement = _a.placement, arrowProps = _a.arrowProps, update = _a.update;
                /**
                 * react-popper has an issue whereby it incorrectly places the tooltip on first render.
                 * As a result, we need to tell it to update its position at the point that it first opens.
                 * The logic here checks that:
                 * 1) the update has not already occurred, and
                 * 2) that either the prop or state used to control tooltip visibilty was previously falsy and is now truthy.
                 */
                if (!tooltipInPosition &&
                    ((!previousOpenPropValue && props.open) ||
                        (!previousOpenStateValue && open))) {
                    void update();
                    setTooltipInPosition(true);
                }
                return (react_1.default.createElement(Popover, { ref: ref, style: style, "data-placement": placement, visible: typeof props.open === 'boolean' ? props.open : open, placement: requestedPlacement, triggerHeight: triggerElementHeight },
                    react_1.default.createElement(TooltipLabel, { role: "tooltip", id: accessibilityId }, tooltipContents),
                    react_1.default.createElement(Arrow, __assign({}, arrowProps, { "data-placement": placement }))));
            }))));
};
exports.Tooltip = Tooltip;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
